<script setup lang="ts">
import ModelAccountWallet from "@models/v2/account/ModelAccountWallet";

interface IProps {
	wallet: ModelAccountWallet
}

defineProps<IProps>();
</script>

<template>
    <div class="balance-wallet-block" v-if="wallet.balance.currency">
        <div class="balance-wallet-block__content">
            <p>{{ $t("g.balance") }} {{ $t('g.bromoney') }}</p>
            <p v-format-number="wallet.balance.amount">
				{{ wallet.balance.amount }} {{ wallet.balance.currency.abbr }}
			</p>
        </div>
    </div>
</template>

<style lang="scss">
.balance-wallet-block {
    &__content {
        display: flex;
        justify-content: space-between;
        background-color: var(--white1);
        border-radius: 18px;
        margin: 16px;
        padding: 12px 16px;

        p:nth-child(1) {
            @include text(14px, 400, var(--grey2));
        }

        p:nth-child(2) {
            @include text(16px, 600, var(--brown1));
        }
    }
}
</style>
